/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
//export const ServerIP = 'http://101.254.112.56:8091/jiaoxue'; //服务器
export const ServerIP = "https://cloud.chinamap.com/jiaoxue"; //云平台服务器
//export const ServerIP = 'http://172.16.90.25:8081';//张迪办公室IP

// 请求图形数据地址
export const shapeServerIP = "https://lbs.chinamap.com";

//云平台（融智汇通）部署配置
//需同步修改ServerIP
export const deployMode = "cloud"; // 'cloud'/'independent'  嵌入云平台部署/独立部署
export const cloudIP = "https://cloud.chinamap.com/"; //http://114.64.231.149/

export const copyRightText =
  "Copyright © 2021　中国地图出版集团中图地理信息有限公司";

export default {
  ServerIP,
  shapeServerIP,
  deployMode,
  cloudIP,
  copyRightText,
};
